import React, { type FC } from "react";
import { GoogleButton } from "@components/GoogleIdentity/GoogleButton";
import useIsGoogleDisabled from "clientState/useIsGoogleDisabled";
import useIsSocialAuthlDisabled from "clientState/useIsSocialAuthlDisabled";
import { Box } from "@edreamsodigeo/prisma-design-system";

import GoogleSeparator from "../SocialAuth/GoogleSeparator";
import { type SocialAuthProps } from "./contract";

const SocialAuth: FC<SocialAuthProps> = ({
  google,
  googleButtonOnTop = false,
}) => {
  const isSocialDisabled = useIsSocialAuthlDisabled();
  const googleDisabled = useIsGoogleDisabled();

  if (isSocialDisabled) return null;

  return (
    <>
      {!googleButtonOnTop && (
        <Box width="100%">
          <GoogleSeparator />
        </Box>
      )}

      {!googleDisabled && <GoogleButton {...google} />}

      {googleButtonOnTop && (
        <Box width="100%">
          <GoogleSeparator />
        </Box>
      )}
    </>
  );
};

export default SocialAuth;
